import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, GridItem, Box, Heading } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

export type StaticReviewCardProps = {
  question: string;
  response: string | undefined;
};

export const StaticReviewCard: React.FC<StaticReviewCardProps> = ({ question, response }) => {
  const { t } = useTranslation('dfi_report_review');

  return (
    <Grid
      borderRadius={5}
      backgroundColor={COLOURS.gray[200]}
      gridGap={8}
      px={5}
      pt={5}
      pb={8}
      className='review-card'
    >
      <GridItem borderTopRadius={5}>
        <Heading size='s' as='h3'>
          {question}
        </Heading>
      </GridItem>
      <GridItem p={5} backgroundColor={COLOURS.white} className='review-card-response'>
        <Box mt={{ base: 4, lg: 'unset' }}>
          <strong>{t('your_response', 'Your response')}</strong>
        </Box>
        <Typography py={2} wordBreak='break-word'>
          <p>{response}</p>
        </Typography>
      </GridItem>
    </Grid>
  );
};
